import { useState, useEffect } from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router";

import { Table, Typography } from "antd";
import _ from "lodash";

import { getCategoryDocsForMemDocPage } from "store/eligibility/documents/actions";
//eligibility info page related
import { SearchCriteria, search } from "store/eligibility/actions";
import { downloadMemberDocument } from "store/eligibility/documents/actions";
import { updateReadInfo } from "store/eligibility/pac/actions";

import { ErrorResponse } from "utils/types";
import { formatDate, handleDownload } from "utils/helpers";
import notifier from "utils/notifier";
import { DocumentCategory, UserRole } from "utils/enums";

const { Title } = Typography;

interface RescindNotesPageProps {
  downloadMemberDocument(memberFilePath: string, memberFileName: string, membMpiNo: string): any;
  updateReadInfo(passedUserId: string, passedPacUid: string, passedPacType: string): any;
  isFetchingForMemDoc: boolean;
  getCategoryDocsForMemDocPage(userId: string, categoryDescArray: string[]): any;

  //eligibility info page related
  search(searchCriteria: SearchCriteria): any;
}

const RescindNotesPage = (props: RescindNotesPageProps) => {
  useEffect(() => {
    getCategoryDocsForMemDocPage();
  }, []);

  const history = useHistory();

  const [rescindNotesDataSource, setRescindNotesDataSource] = useState<Object[]>([]);

  const rescindColumns = [
    {
      title: "Member ID",
      key: "RmiMembId",
      dataIndex: "RmiMembId",
      render: (_: string, record: any) => <a onClick={() => switchToEligibityDetailPage(record)}>{record.RmiMembId}</a>,
      sorter: (a: any, b: any) => a.RmiMembId.localeCompare(b.RmiMembId),
    },
    {
      title: "Member Name",
      key: "RmiRevFullName",
      dataIndex: "RmiRevFullName",
      sorter: (a: any, b: any) => a.RmiRevFullName.localeCompare(b.RmiRevFullName),
    },
    {
      title: "File Name",
      key: "RmiOrigFileName",
      dataIndex: "RmiOrigFileName",
      render: (_: string, record: any) => <a onClick={() => downloadMemberDocument(record, DocumentCategory.RESCIND_NOTICE)}>{record.RmiOrigFileName}</a>,
      sorter: (a: any, b: any) => a.RmiOrigFileName.localeCompare(b.RmiOrigFileName),
    },
    {
      title: "Upload Date",
      key: "RmiUploadDate",
      dataIndex: "RmiUploadDate",
      render: (_: string, record: any) => formatDate(record.RmiUploadDate, 'MM/DD/YYYY [at] h:mmA'),
      sorter: (a: any, b: any) => a.RmiUploadDate.localeCompare(b.RmiUploadDate),
    },
    {
      title: "Read By",
      key: "RmiReadBy",
      dataIndex: "RmiReadBy",
      sorter: (a: any, b: any) => {
        a = a.RmiReadBy || '';
        b = b.RmiReadBy || '';
        return a.localeCompare(b);
      },
    },
    {
      title: "Read Date",
      key: "RmiReadDate",
      dataIndex: "RmiReadDate",
      render: (_: string, record: any) => formatDate(record.RmiReadDate, 'MM/DD/YYYY [at] h:mmA'),
      sorter: (a: any, b: any) =>  {
        a = a.RmiReadDate || '';
        b = b.RmiReadDate || '';
        return a.localeCompare(b);
      },
    },
  ];

  //Update Read Info API after you click on download member document link
  const updateReadInfo = (document: any, pacType: string) => {
    return props.updateReadInfo(sessionStorage.user_id, document.RmiUid, pacType)
      .then(() => {
        // onShowTable(table); //recalls the API to get the updated read by and read date
      })
      .catch((err: ErrorResponse) =>
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.')
      );
  }

  //Download Documents API when you click on the links on the table
  //document too long to define
  const downloadMemberDocument = (documentFile: any, pacType: string) => {
    return props.downloadMemberDocument(documentFile.RmiFilePath, documentFile.RmiFileName, documentFile.RmiUid)
      .then((response: any) => {
        handleDownload(response, documentFile.RmiFileName);
        updateReadInfo(documentFile, pacType);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.')
      });
  }

  const switchToEligibityDetailPage = (memberInfo: any) => {
    //According to legacy code
    const provider = (sessionStorage.user_role === UserRole.CASE || sessionStorage.user_role === UserRole.IPA) ? "OTHER" : "PCP";
    let formData = {
      "DateOfBirth": memberInfo.RmiBirth,
      "MemberId": memberInfo.RmiMembId,
      "Provider": provider,
      "UserId": sessionStorage.user_id
    }

    return props.search(formData)
      .then((response: any) => {
        if(response.length > 0) {
          history.push({
            pathname: '/eligibility/member-detail',
            state: {
              eligibilityMemberInfo: response[0]
            }
          });

        } else {
          notifier.error('No access. Please use eligibility to search for this member.');
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }


  //CCS Aging Out Documents, Rescind Notice, Member Roster, Consult Notes (aka Specialist Notes) API shares the same API. Just need to pass in category.
  const getCategoryDocsForMemDocPage = () => {
    const documentCategories = [DocumentCategory.RESCIND_NOTICE];
    return props.getCategoryDocsForMemDocPage(sessionStorage.user_id, documentCategories)
      .then((response: Object[]) => {
        setRescindNotesDataSource(_.orderBy(response, 'RmiUploadDate', 'desc'));
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  return (
    <div className="documents-page">
      <div className="header-title">
        <Title level={4} className="ml-3">Rescind Notes</Title>
      </div>

      <div className="search-section">
        <Table
          columns={rescindColumns}
          dataSource={rescindNotesDataSource}
          pagination={{ position: ["bottomCenter"] }}
          loading={props.isFetchingForMemDoc}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingForMemDoc: store.rootReducer.eligibilityDocuments.isFetchingForMemDoc, //Rescmind Notice
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getCategoryDocsForMemDocPage,
    downloadMemberDocument,
    updateReadInfo,

    //eligibility info page related
    search,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(RescindNotesPage);
